import { render, staticRenderFns } from "./board_new_issue.vue?vue&type=template&id=32c0e846&"
import script from "./board_new_issue.vue?vue&type=script&lang=js&"
export * from "./board_new_issue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "board_new_issue.vue"
export default component.exports